import moment from "moment-timezone";
import { APP_CONST } from "@/store/dataStore";

export function outsideDateRange(startDate, endDate, date) {
  return (
    (endDate &&
      !startDate &&
      (moment(date).isAfter(
        (endDate ? moment(endDate) : moment())
          .tz("Asia/Phnom_Penh")
          .endOf("day"),
      ) ||
        moment(date).isBefore(
          (endDate ? moment(endDate) : moment())
            .tz("Asia/Phnom_Penh")
            .endOf("day")
            .subtract(APP_CONST.REPORT_BACK_DAYS() + 1, "days"),
        ))) ||
    (startDate &&
      !endDate &&
      (moment(date).isAfter(
        (startDate ? moment(startDate) : moment())
          .tz("Asia/Phnom_Penh")
          .endOf("day")
          .add(APP_CONST.REPORT_BACK_DAYS(), "days"),
      ) ||
        moment(date).isBefore(
          (startDate ? moment(startDate) : moment())
            .tz("Asia/Phnom_Penh")
            .endOf("day")
            .subtract(1, "days"),
        ))) ||
    (startDate &&
      endDate &&
      (moment(date).isAfter(
        (endDate ? moment(endDate) : moment())
          .tz("Asia/Phnom_Penh")
          .endOf("day"),
      ) ||
        moment(date).isBefore(
          (endDate ? moment(endDate) : moment())
            .tz("Asia/Phnom_Penh")
            .endOf("day")
            .subtract(APP_CONST.REPORT_BACK_DAYS(), "days"),
        )))
  );
}
